export enum PRESAVE_PARAMS {
  CURRENT_LOCALE = 'auth/currentLocal',
  ACCOUNT_NUMBER = 'auth/accountNumber',
  SECOND_ATTEMPT = 'auth/secondAttempt',
  SCRATCH_CARD = 'auth/scratch/card',
  SCRATCH_CODE_NUMBER = 'auth/scratch/codeNumber',
  SCRATCH_AVAILABLE_KEYS_COUNT = 'auth/scratch/availableKeysCount',
  ACCOUNT_PHONE = 'auth/phone',
  ACCOUNT_USERNAME = 'auth/username',
  ACCOUNT_PHONE_LAST_DIGITS = 'auth/phoneLastDigits',
  LOGIN_TYPE = 'auth/loginType',
  REGISTER_HAS_PHONE_SWITCHER = 'auth/registerHasPhoneSwitcher',
}
